<div class="d-flex flex-column info">
  <div class="d-flex align-items-center">
    <img src="/assets/icons/luggage.svg" alt="luggage" width="24" height="24" />
    <h3 class="semi-bold ml-2">Your next adventure awaits!</h3>
  </div>

  <p class="mt-2">
    Tell us about your dream trip, and we’ll take care of the details. Let’s make it happen—start
    planning today!
  </p>

  <!-- <ds-button
    (click)="startPlanning.emit()"
    variant="secondary"
    label="Start planning your next trip"
    class="mt-4 mt-md-6"
    data-id="start-planning"
  /> -->
</div>

<img src="/assets/images/earth.svg" alt="earth" class="ml-5 earth" />
